import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useAdminReviewList(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const approve = useCallback(async (reviewId) => {
    console.log("APPROVE", reviewId);
    const { response } = await API.admin.approveReview(token, reviewId);

    if (response.ok) {
      const newResult = { ...result };
      newResult.results = newResult.results.map(result => {
        if (result.id === reviewId) {
          result.status = "approved";
        }

        return result;
      });

      setResult(newResult);
    }
  }, [result, token]);

  const reject = useCallback(async (reviewId) => {
    console.log("REJECT", reviewId);
    const { response } = await API.admin.rejectReview(token, reviewId);

    if (response.ok) {
      const newResult = { ...result };
      newResult.results = newResult.results.map(result => {
        if (result.id === reviewId) {
          result.status = "rejected";
        }

        return result;
      });

      setResult(newResult);
    }
  }, [result, token]);

  useEffect(() => {
    async function fetchAdminReviews() {
      setLoading(true);
      const { response, data } = await API.admin.fetchReviewList(token, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      } else {
        console.error(data);
      }
    }

    fetchAdminReviews();
  }, [Object.values(filters).join("__")]);

  return {
    approve,
    reject,
    loading,
    reviews: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
